// extracted by mini-css-extract-plugin
module.exports = {"item":"RadioList_item__3bWZu","text":"RadioList_text__1tl31"};